import { type WizardStep } from '@synqo/frontend-component-library';
import { useMemo, useRef } from 'react';
import { type Skipping, StepOnWhenAnswered } from './StepOnWhenAnswered';

/**
 * The steps, walked through on their own up to the last one while each validates, as "Weiter" would.
 * The walk ends at the first step that refuses, and for good once it has ended.
 */
// @ai-generated 2026-09-29T09:54:18+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function useAnsweredStepsSkipped<TData>(steps: WizardStep<TData>[], enabled: boolean): WizardStep<TData>[] {
    const skipping = useRef<Skipping>({ active: enabled, from: undefined });

    return useMemo(
        () =>
            enabled
                ? steps.map((step) => ({
                      ...step,
                      render: (context) => (
                          <>
                              <StepOnWhenAnswered skipping={skipping} />
                              {step.render(context)}
                          </>
                      ),
                  }))
                : steps,
        [steps, enabled],
    );
}
